import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { EnvironmentService } from '@nomoh-monorepo/shared-data-access-environment';
import { lastValueFrom } from 'rxjs';
import { IDashboardData } from './models/feature-dashboard.interface';

@Injectable({ providedIn: 'root' })
export class FeatureDashboardDataService {
  //#region Injeção de dependencia
  private http = inject(HttpClient);
  private environment = inject(EnvironmentService);
  //#endregion Injeção de dependencia

  //#region Estado com Signals (padrão KISS)
  private _dashboardData = signal<IDashboardData | null>(null);
  private _loading = signal<boolean>(false);
  //#endregion Signals públicos

  $dashboardData = this._dashboardData.asReadonly();
  $loading = this._loading.asReadonly();

  private _baseUrl = `${this.environment.getApiUrl('nomoh')}/pessoa/admin`;

  async carregarDashboard(): Promise<void> {
    this._loading.set(true);

    try {
      const dados = await lastValueFrom(
        this.http.get<IDashboardData>(`${this._baseUrl}/infoPessoas`)
      );

      this._dashboardData.set(dados);
    } finally {
      this._loading.set(false);
    }
  }
}
